module.exports = __webpack_public_path__ + "public/img/fwwl.85b5fc1d.png";